module.exports = __webpack_public_path__ + "img/home-11-2.f99af253.png";